module.exports = __webpack_public_path__ + "img/vazio_2_cinza.506fbcff.svg";